/**
 * Language Configuration
 * This file is auto-generated based on the LANGUAGE environment variable
 * Used to configure the site language
 * 
 * Generated at: 2026-11-03T19:45:24.994Z
 */

// Language code from environment variable (set at build time)
export const LANGUAGE = 'en'

export default LANGUAGE
